import React from 'react';
import SparePartInput from '../PartsComponent';
import { RepairTableStyles as styles } from './RepairTableStyles';

interface RepairActionModalProps {
  showModal: boolean;
  selectedRepair: any;
  mechanics: any[];
  updateForm: any;
  setUpdateForm: (form: any) => void;
  loading: boolean;
  spareParts: any[];
  setSpareParts: (parts: any[]) => void;
  onClose: () => void;
  onSubmit: () => void;
}

export const RepairActionModal: React.FC<RepairActionModalProps> = ({
  showModal,
  selectedRepair,
  mechanics,
  updateForm,
  setUpdateForm,
  loading,
  spareParts,
  setSpareParts,
  onClose,
  onSubmit
}) => {
  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modal}>
        <h2 style={styles.modalTitle}>Update Repair</h2>
        {updateForm.statusID !== 8 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <SparePartInput
              repair={selectedRepair}
              spareParts={spareParts}
              setSpareParts={setSpareParts}
            />
          </div>
        )}

        {updateForm.statusID === 2 && (
          <div style={styles.formGroup}>
            <label style={styles.label}>Assign To:</label>
            <select
              style={styles.input}
              value={updateForm.assignedTo}
              onChange={(e) =>
                setUpdateForm({ ...updateForm, assignedTo: e.target.value })
              }
            >
              <option value="">Select Mechanic</option>
              {mechanics.map((mechanic) => (
                <option key={mechanic.UserID} value={mechanic.UserID}>
                  {mechanic.FullName}
                </option>
              ))}
            </select>
          </div>
        )}

        {updateForm.statusID === 3 && (
          <div style={styles.formGroup}>
            <label style={styles.label}>Mechanic Notes:</label>
            <textarea
              style={{ ...styles.input, height: "100px" }}
              value={updateForm.mechNotes}
              onChange={(e) =>
                setUpdateForm({ ...updateForm, mechNotes: e.target.value })
              }
            />
          </div>
        )}

        {(updateForm.statusID === 4 || updateForm.statusID === 99) && (
          <div style={styles.formGroup}>
            <div>Please approve or reject repairs:</div>
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px",
                border: "1px solid #e0e0e0",
                borderRadius: "5px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="checkbox"
                  name="approveRepair"
                  checked={updateForm.statusID === 4}
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      statusID: e.target.checked ? 4 : null,
                    });
                  }}
                  style={{ marginRight: "5px" }}
                />
                Approve
              </label>

              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="checkbox"
                  name="rejectRepair"
                  checked={updateForm.statusID === 99}
                  onChange={(e) => {
                    setUpdateForm({
                      ...updateForm,
                      statusID: e.target.checked ? 99 : null,
                    });
                  }}
                  style={{ marginRight: "5px" }}
                />
                Reject
              </label>
            </div>
          </div>
        )}

        {updateForm.statusID === 5 && (
          <div style={styles.formGroup}>
            <label style={styles.label}>Booked Date:</label>
            <input
              type="date"
              style={styles.input}
              value={updateForm.BookedDate}
              onChange={(e) =>
                setUpdateForm({ ...updateForm, BookedDate: e.target.value })
              }
            />
          </div>
        )}

        {updateForm.statusID === 6 && (
          <div style={styles.formGroup}>
            <label style={styles.label}>Date Received:</label>
            <input
              type="date"
              style={styles.input}
              value={updateForm.ReceivedDate}
              onChange={(e) =>
                setUpdateForm({
                  ...updateForm,
                  ReceivedDate: e.target.value,
                })
              }
            />
          </div>
        )}

        {updateForm.statusID === 7 && (
          <div style={styles.formGroup}>
            <label style={styles.label}>Release Notes:</label>
            <textarea
              style={{ ...styles.input, height: "100px" }}
              value={updateForm.ReleaseNote}
              onChange={(e) =>
                setUpdateForm({
                  ...updateForm,
                  ReleaseNote: e.target.value,
                })
              }
            />
          </div>
        )}

        {updateForm.statusID === 8 && (
          <div style={styles.formGroup}>
            <label style={styles.label}>Repair Cost:</label>
            <input
              type="number"
              style={styles.input}
              value={updateForm.repairCost}
              onChange={(e) =>
                setUpdateForm({ ...updateForm, repairCost: e.target.value })
              }
            />
          </div>
        )}

        <div style={styles.modalButtons}>
          <button
            style={{ ...styles.button, backgroundColor: "#007bff" }}
            onClick={onSubmit}
            disabled={loading}
          >
            {loading ? "Updating..." : "Submit"}
          </button>
          <button
            style={{ ...styles.button, backgroundColor: "#6c757d" }}
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};